document.addEventListener("DOMContentLoaded", function () {
  const toggleButtons = document.querySelectorAll('[id^="toggle-"]');
  
  toggleButtons.forEach(function(toggleButton) {
    const sectionId = toggleButton.id.replace('toggle-', '');
    const textElement = document.getElementById("text");

    if (toggleButton && textElement) {
      toggleButton.addEventListener("click", function () {
        if (toggleButton.textContent.trim() === "Learn More") {
          toggleButton.textContent = "Read Less";
          textElement.style.display = "block"; 
        } else {
          toggleButton.textContent = "Learn More";
          textElement.style.display = "none";
        }
      });
    }
  });
});

